import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-component-shared-button-config',
  templateUrl: 'button-config.component.html'
})
export class EditorSharedButtonConfigComponent implements OnInit {
  @Input() button: any;
  @Output() buttonChange = new EventEmitter<any>();
  @Input() customData: any;
  @Input() title: string;

  ngOnInit() {
    if (!this.button) {
      this.button = {
        text: 'Começar',
        color: '#ffffff',
        background: '#222222'
      };
      setTimeout(() => this.buttonChange.emit(this.button));
    }
  }
}
